import React from "react";


function FlipHorizontal( { onTransform, disabled } ) {

  /**
   * Flips the object horizontally when the user clicks the "Flip Horizontal" button.
   *
   * @param {Event} event - The click event object.
   * @returns {void}
   */
  const flipObject = (event ): void => {
    if (!disabled) {
      onTransform( event, "flip", "X" );
    }
  };

  return (
    <div
      className="toolbar-button"
      data-test={"image-flip-h"}
      onClick={ flipObject }
      style={disabled ? { opacity: 0.5, cursor: "not-allowed" } : {}}>
      <i className="fas fa-arrows-alt-h"></i>
    </div>
  );
}

export default FlipHorizontal;